import React, { useEffect, useState } from 'react'
import moment from 'moment'
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation"
import { PB_RateType } from '../../constants/rateTypes'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { getBase64Encoded, setToSessionStorage } from '../../utils/StorageUtils'
import sessionKeys from '../../constants/sessionKeys'
import getCurrentUser from "../../utils/getCurrentUser";


const PermanentBookingItem = ({
    bookingItem,
    flag,
    fileName,
    bookingFilter,
    setBookingList,
    setAutoRefresh,
    setEditButtonActive,
    isEditButtonActive,
    clearToken,
    sortedArray,
    index,
    setAlertMessage,
    setStatus,
    isMassUpload
}) => {
    const [isViewMode, setViewMode] = useState(false);
    const [isEditMode, setEditMode] = useState(false);
    const { t } = useTranslation(['labels', 'errors']);
    const history = useHistory()

    let parsedbookingItem = JSON.parse(bookingItem?.requestParameters);

    useEffect(() => {
        if (flag) {
            setViewMode(false);
            setEditMode(false);
        }
    }, [flag]);

    const getAwbNumber = (awbNumber) => {
        if (!awbNumber) return '';
        return awbNumber.substring(0, 3) + '-' + awbNumber.substring(3);
    };

    const changeEditMode = (currentEditMode) => {
        clearInterval(clearToken);
        if (!currentEditMode) setAutoRefresh();
        setEditMode(!isEditMode);
    };

    const shouldRender =
        (bookingFilter.confirmed && bookingItem.status === "Confirmed") ||
        (bookingFilter.queued && bookingItem.status === "Queued") ||
        (bookingFilter.tobeProcessed && bookingItem.status === "To be Processed") ||
        (bookingFilter.failed && bookingItem.status === "Failed") ||
        (bookingItem.status === "Loading");


    useEffect(() => {
        if (
            history.location.state &&
            history.location.state.message
        ) {
            const message = history.location.state.message
            const status = history.location.state.success

            setAlertMessage(message)
            setStatus(status)

            let state = { ...history.location.state }
            delete state.message
            delete state.success
            history.replace({ ...history.location, state })
            window.scrollTo(0, 0)
        }
    }, [history])


    const handleMutlipleBookingNav = (isEditMode, awbNumber, ubrNumber) => {
        const { requestParameters, ...rest } = bookingItem;
        const parsedAwb = isEditMode ? `${parsedbookingItem?.shipmentIdentifierDetails?.shipmentPrefix || ''}${parsedbookingItem?.shipmentIdentifierDetails?.masterDocumentNumber || ''}` : awbNumber;
        const fullBookingData = { ...rest, awbNumber: getAwbNumber(parsedAwb), bookingDetails: parsedbookingItem };
        const sessionStoreObj = { fileName, isMassUpload, fullBookingData }
        setToSessionStorage(sessionKeys.MULTIPLE_BOOKING_DATA, getBase64Encoded(sessionStoreObj));
        if (isEditMode) {
            history.push(`/permanent-booking/edit/`)
        } else if (awbNumber) {
            history.push(`/permanent-booking/view/${awbNumber}${ubrNumber ? `/${ubrNumber}` : ''}`)
        } else {
            history.push(`/permanent-booking/view/`)
        }
    }
     const toUpperSafe = (val) =>
      val !== undefined && val !== null ? String(val).toUpperCase() : '';

    const getEnglishShippingDate = (shippingDate) => {
        if (!shippingDate) return '';

        const parsedDate = moment(shippingDate, ['DD-MMM-YYYY', moment.ISO_8601], true);
        return parsedDate.isValid()
            ? parsedDate.locale('en').format('DD-MMM-YYYY')
            : shippingDate;
    };

     const isInterlineAgent = getCurrentUser()?.interlineAgent === 'Y';
    return (
        <>
            {shouldRender && (
                <tr className={`body-row ${(index === 0 || index % 2 === 0) ? 'even' : ''}`}>
                    <td className="body-cells">
                        {parsedbookingItem?.shipmentDetails?.shipmentOrigin}&nbsp;-&nbsp;
                        {parsedbookingItem?.shipmentDetails?.shipmentDestination}
                    </td>
                    <td className="body-cells">{toUpperSafe(parsedbookingItem?.shipmentDetails?.productDetails?.productName)}</td>
                    <td className="body-cells">
                        <span dir="ltr" style={{ unicodeBidi: 'isolate' }}>
                            {getEnglishShippingDate(parsedbookingItem?.shipmentDetails?.shippingDate)}
                        </span>
                    </td>
                    {(parsedbookingItem?.rate === null || parsedbookingItem?.rate === 0) ? (
                        bookingItem?.awbNumber ? (
                            <>
                                <td className="body-cells">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-</td>
                                <td className="body-cells">{t("COMMON.NO_RATES")}</td>
                            </>
                        ) : (
                            <>
                                <td className="body-cells">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                                <td className="body-cells"></td>
                            </>
                        )
                    ) : (
                        isInterlineAgent ? (
                            <>
                                <td className="body-cells">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-</td>
                                <td className="body-cells">{t("COMMON.NO_RATES")}</td>
                            </>
                        ) : (
                            <>
                                <td className="body-cells">{PB_RateType[parsedbookingItem?.priceClass]}</td>
                                <td className="body-cells">{parsedbookingItem?.shipmentDetails?.currency} {parsedbookingItem?.rate}</td>
                            </>
                        )
                    )}
                    <td className="body-cells">{getAwbNumber(bookingItem?.awbNumber)}</td>
                    <td className="body-cells">
                        {bookingItem?.status === "Loading" ? <LoadingAnimation /> : bookingItem?.status}
                    </td>
                    <td
                        style={{ cursor: bookingItem?.status === "Loading" ? '' : "pointer" }}
                        className="body-cells link-color"
                        onClick={() => {
                            if (bookingItem?.status === "Loading") return;
                            handleMutlipleBookingNav(bookingItem?.status === "Failed", bookingItem?.awbNumber, bookingItem?.ubrNumber)
                        }}
                    >
                        {bookingItem?.status === "Failed" ? (
                            t('COMMON.EDIT')
                        ) : (
                            t('COMMON.VIEW')
                        )}
                    </td>
                </tr>
            )}
        </>
    );
};

export default PermanentBookingItem;